import {isArray} from "lodash"
/** Initial helper reference */
const helper = {}

/**
 *
 * Helper to run common requests
 * @param teams
 * @returns array
 */

helper.getRemainingTeams = (teams) => {
  return teams && isArray(teams) ? teams.slice(2) : []
}

helper.getVisibleTeams = (teams) => {
  return teams && isArray(teams) ? teams.slice(0, 2) : []
}

/** export helpers individually */
export const getRemainingTeams = helper.getRemainingTeams

export const getVisibleTeams = helper.getVisibleTeams

/** export default helper obj */
export default helper
